export default (middlewares) => {
  return async (options) => {
    const { api, query, meta = {} } = options;
    let middlewaresCopy = middlewares.slice();

    const res = await {
      ...options,
      origin: { api, query },
      meta,
      async next(params) {
        const middleware = middlewaresCopy.shift();
        // 最后一次调用重置middlewaresCopy让下次调用报错
        if (!middleware) {
          middlewaresCopy = undefined;
        } else {
          await middleware.call(this, this, params);
        }
        return this;
      },
    }.next();

    return res;
  };
};
